import * as React from "react";
import { useRef } from "react";
import lowerCase from "lodash/lowerCase";
import { Tooltip } from "components/common";
import useEntityCollectionStatus from "collections/hooks/useEntityCollectionStatus";
import { getValuesFromGRN } from "logic/permissions/GRN";
import TitleCell from "collections/components/EntitiesList/cells/TitleCell";
import { useTranslation } from "react-i18next";
const SharedEntityCollectionCell = ({ entityId, entityType }) => {
  const { t } = useTranslation("enterprise_collections");
  const { id } = getValuesFromGRN(entityId);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityId, id);
  const count = (data == null ? void 0 : data.length) || 0;
  const isDisabled = count === 0;
  const spanRef = useRef();
  if (isFetching || isError) {
    return null;
  }
  const label = /* @__PURE__ */ React.createElement("span", null, t("shared_entities_collection_cell.label", { count, entityType: lowerCase(entityType) }));
  return /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "right", label, disabled: isDisabled }, /* @__PURE__ */ React.createElement("span", { ref: spanRef }, count > 0 && /* @__PURE__ */ React.createElement(TitleCell, { name: data[0].title, type: "collection", id: data[0].id }), count > 1 && /* @__PURE__ */ React.createElement("span", null, t("shared_entities_collection_cell.more", { number: count - 1 })))));
};
export default SharedEntityCollectionCell;
